import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    id: 1,
    quote:
      "Fortress Integration transformed our estate into an impenetrable sanctuary. The level of expertise and attention to detail is unmatched. True professionals.",
    name: "James Sterling",
    role: "Estate Owner, Atherton",
    image:
      "https://images.unsplash.com/photo-1770452603217-89b4f03e8271?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxjb25maWRlbnQlMjBwcm9mZXNzaW9uYWwlMjBtYW4lMjBwb3J0cmFpdCUyMHN1aXQlMjBkYXJrJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzI1OTI3NjJ8MA&ixlib=rb-4.1.0&q=85",
    rating: 5,
  },
  {
    id: 2,
    quote:
      "Finally, a team that understands privacy isn't optional — it's essential. Our home automation is seamless, secure, and completely under our control.",
    name: "Elena Vance",
    role: "Interior Designer",
    image:
      "https://images.unsplash.com/photo-1771862860974-63d7816c0991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwcHJvZmVzc2lvbmFsJTIwd29tYW4lMjBwb3J0cmFpdCUyMHNtaWxpbmclMjBsdXh1cnklMjBob21lJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzI1OTI3NjN8MA&ixlib=rb-4.1.0&q=85",
    rating: 5,
  },
  {
    id: 3,
    quote:
      "The local AI integration is remarkable. Voice control that actually works, without any data leaving our property. This is what smart home should be.",
    name: "Michael Chen",
    role: "Tech Executive",
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Background Glow */}
      <div className="section-glow-right" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-12 bg-[#5e5ce6]" />
            <span className="text-xs uppercase tracking-[0.2em] text-[#5e5ce6] font-medium">
              Client Stories
            </span>
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold tracking-tight text-white max-w-xl"
            data-testid="testimonials-headline"
          >
            Trusted by those who demand the best
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group glass-card glass-card-hover rounded-3xl p-8 relative"
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 w-10 h-10 rounded-xl bg-[#5e5ce6]/10 flex items-center justify-center">
                <Quote className="w-5 h-5 text-[#5e5ce6]" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-4 h-4 text-[#5e5ce6] fill-[#5e5ce6]"
                  />
                ))}
              </div>

              {/* Quote */}
              <p className="text-base text-white/70 leading-relaxed mb-8">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-white/5">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-white/10">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-white/40">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
